import Cookies from 'js-cookie';

export const parseJwt = token => {
  try {
    let base64String = token.split('.')[1];
    base64String = base64String.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64String)
        .split('')
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    return '';
  }
};

export const validateAuthCookie = shouldSaveRedirectUrl => {
  const authCookie = Cookies.get('auth');

  let validity = false;
  let token = '';
  if (authCookie) {
    token = parseJwt(authCookie);
    if (token && token.nameid) {
      validity = true;
    }
  } else if (shouldSaveRedirectUrl) {
    Cookies.set('hbReturnURL', window.location.href);
  }
  return validity;
};

export const getAuthCookieInfo = () => {
  const authCookie = Cookies.get('auth');

  return {
    authToken: authCookie,
  };
};
